import { css, cx } from "@emotion/css"

import useHover from "../../hooks/useHover"

type AnchorProps = {
  newTab?: boolean
  hoverClassName?: string
  render?: (state: { isHovered: boolean }) => React.ReactNode
  useBrowserDefaultStyle?: boolean
} & JSX.IntrinsicElements["a"]

/**
 * @deprecated
 * 以下の理由から作成したコンポーネントですが、役割が薄くなったため今後はaタグを直接使用してください。
 *
 * 1. target="_blank" を設定した場合に rel="noopener noreferrer" を強制的に付与することが目的でした。
 *    2022年現在のモダンブラウザはrelを明示的に指定していなくてもnoopenerとして扱われます。
 *    @see https://github.com/jsx-eslint/eslint-plugin-react/blob/master/docs/rules/jsx-no-target-blank.md#when-to-override-it
 *
 * 2. hover時のPCとモバイルの差異を吸収する目的で使用していました。
 *    しかし、ほとんどのユーザーがPCのためCSSのhoverを使うので十分です。
 *    PCとモバイルの差異を意識する必要がある場合は直接useHoverを使用してください。
 */
const Anchor = ({
  newTab = false,
  hoverClassName,
  render,
  useBrowserDefaultStyle = false,
  className,
  children,
  target,
  rel,
  ...props
}: AnchorProps) => {
  const { isHovered, hoverProps } = useHover()

  return (
    <a
      {...props}
      {...hoverProps}
      target={newTab ? "_blank" : target}
      rel={newTab ? "noopener noreferrer" : rel}
      className={cx(!useBrowserDefaultStyle && style, className, isHovered && hoverClassName)}
    >
      {render ? render({ isHovered }) : children}
    </a>
  )
}

export default Anchor

const style = css`
  color: inherit;
  text-decoration: none;
`
